import { isFiniteNumber } from '../Number/isFiniteNumber'

export const castToFiniteNumber = (x: string): number | null => {
  const parsed = parseFloat(x)
  const result = isFiniteNumber(parsed) ? parsed : null
  return result
}
